var React = require('react');

function Cowbell (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M176.32 96H112.2V48a48.1 48.1 0 0 1 48.09-48h128.23a48.1 48.1 0 0 1 48.09 48v48h-64.12V64h-96.17z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M447.49 474.35A32 32 0 0 1 415.93 512H32.07A32 32 0 0 1 .51 474.35l63.29-352A32.06 32.06 0 0 1 95.36 96h257.28a32.06 32.06 0 0 1 31.56 26.35z","className":"fa-primary","key":2})]);
}

Cowbell.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = Cowbell;

Cowbell.default = Cowbell;
